var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateBellError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.892 53.916c14.866 0 26.917-12.051 26.917-26.916S42.758.084 27.892.084C13.026.084.976 12.135.976 27s12.05 26.916 26.916 26.916z",
    fill: "#f9dad0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.696 34.563H30.713v-2.291h12.295a.936.936 0 00.677-.286.932.932 0 00.265-.685 15.999 15.999 0 00-1.406-6.11 16.113 16.113 0 00-3.491-4.973 16.094 16.094 0 00-9.775-4.498v-2.479c0-.136.111-.247.248-.247.317 0 .615-.123.84-.348.223-.224.346-.52.346-.837v-.624c0-.654-.532-1.185-1.186-1.185h-3.494c-.655 0-1.187.531-1.187 1.185v.624c0 .653.532 1.185 1.187 1.185a.248.248 0 01.247.247v2.48a16.093 16.093 0 00-9.774 4.497 16.114 16.114 0 00-3.492 4.972 16.006 16.006 0 00-1.406 6.111c-.008.257.087.5.266.685.179.184.42.286.676.286h12.296v2.29H13.861a2.255 2.255 0 00-2.255 2.252v4.451h32.345v-4.452a2.255 2.255 0 00-2.255-2.25z",
    fill: "#F0A48B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.607 31.851c0-8.945 7.251-16.197 16.197-16.197 8.946 0 16.198 7.252 16.198 16.197v.417H11.606v-.417z",
    fill: "#EA7F5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.711 27.692H24.9v.844h5.811v-.844z",
    fill: "#9e320f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.075 22.96l1.74 1.742-.596.596-1.74-1.74-1.741 1.74-.597-.596 1.74-1.741-1.771-1.772.596-.597 1.772 1.772 1.772-1.772.597.597-1.772 1.772zM22.725 22.96l1.74 1.742-.596.596-1.74-1.74-1.741 1.74-.597-.596 1.74-1.741-1.771-1.772.596-.597 1.772 1.772 1.772-1.772.597.597-1.772 1.772z",
    fill: "#9e320f"
  })));
}

export default SvgEmptyStateBellError;